/** Bottom-border-only fields (legacy / clean form look). */
const FORM_CONTROL_BASE =
  'w-full border-0 border-b border-gray-300 rounded-none bg-transparent px-0 py-2 text-sm text-gray-900 shadow-none focus:border-primary focus:outline-none focus:ring-0';

export const formControlClass = FORM_CONTROL_BASE;

export const formControlDisabledClass = `${FORM_CONTROL_BASE} disabled:bg-gray-50 disabled:text-gray-500`;

export const formControlReadonlyClass =
  'w-full border-0 border-b border-gray-300 rounded-none bg-gray-50 px-0 py-2 text-sm text-gray-700 font-medium shadow-none';

export const formControlClientAmountClass =
  'w-full border-0 border-b border-gray-300 rounded-none bg-blue-50 px-0 py-2 text-sm font-semibold text-blue-900 shadow-none';

export const formControlCustomerAmountClass =
  'w-full border-0 border-b border-gray-300 rounded-none bg-green-50 px-0 py-2 text-sm font-semibold text-green-900 shadow-none';

export const formControlTextareaClass = `${FORM_CONTROL_BASE} resize-none`;

/** Multi-select dropdown trigger (button styled like underline inputs). */
export const formMultiSelectTriggerClass = `${FORM_CONTROL_BASE} text-left flex items-center justify-between cursor-pointer`;

export const formMultiSelectTriggerDisabledClass = `${formMultiSelectTriggerClass} disabled:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-60`;
